/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerSearchModel } from '../../models/practitioner-search-model';
import { PractitionerSearchResultModel } from '../../models/practitioner-search-result-model';

export interface AdminSearchPost$Params {
      body?: PractitionerSearchModel
}

export function adminSearchPost(http: HttpClient, rootUrl: string, params?: AdminSearchPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<PractitionerSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, adminSearchPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<Array<PractitionerSearchResultModel>>;
    })
  );
}

adminSearchPost.PATH = '/Admin/Search';
